module.exports = __webpack_public_path__ + "static/2-5c0496ee9c963b102f176db271156cc7.jpeg";